import { Component, OnInit, ChangeDetectionStrategy, Self, Optional, Input } from '@angular/core';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';
import { BaseInputComponent } from '../base-input';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'stp-input-percent',
  templateUrl: './input-percent.component.html'
})
export class InputPercentComponent extends BaseInputComponent implements OnInit {

  @Input() step = 0.01;
  @Input() min = 0;
  @Input() max = 100;

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  writeValue(obj: any) {
    super.writeValue(parseFloat((obj * 100).toFixed(2)));
  }

  registerOnChange(fn: any) {
    super.registerOnChange((value: string) => {
      if (value === '') {
        fn(value);
      } else {
        fn(+value / 100);
      }
    });
  }
}
